import React from 'react';
import '../styles/LegalPages.css';

const ImpressumPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Impressum</h1>
        <p className="last-updated">Stand: August 2026</p>

        <h2>Betreiberin dieser Webseite</h2>
        <div className="contact-box">
          <p style={{ marginBottom: 4 }}><strong>WennWieWo</strong></p>
          <p style={{ marginBottom: 0 }}>E-Mail: kontakt@wennwiewo.ch</p>
        </div>

        <h2>Inhalt der Webseite</h2>
        <p>
          WennWieWo ist eine Schweizer Eventplattform, die Veranstaltungen aus der ganzen Schweiz
          bündelt und öffentlich zugänglich macht. Veranstalterinnen und Veranstalter können
          eigene Events erfassen und verwalten.
        </p>

        <h2>Haftungsausschluss</h2>

        <h3>Inhalt</h3>
        <p>
          Die Inhalte dieser Webseite werden mit grösstmöglicher Sorgfalt erstellt und
          gepflegt. WennWieWo übernimmt jedoch keine Gewähr für die Richtigkeit,
          Vollständigkeit und Aktualität der bereitgestellten Inhalte. Die Nutzung der
          Webseite erfolgt auf eigene Gefahr.
        </p>
        <p>
          Für Veranstaltungsinformationen (Datum, Ort, Preis, etc.), die von Veranstalterinnen
          und Veranstaltern selbst eingetragen wurden, übernimmt WennWieWo keine Haftung.
          Massgeblich sind die Angaben der jeweiligen Veranstalterinnen und Veranstalter.
        </p>

        <h3>Externe Links</h3>
        <p>
          Diese Webseite enthält Links zu externen Webseiten Dritter. Auf deren Inhalte haben
          wir keinen Einfluss und übernehmen dafür keine Haftung. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die durch WennWieWo erstellten Inhalte und Werke auf dieser Webseite unterliegen dem
          Schweizer Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung ausserhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
        <p>
          Inhalte (Texte, Bilder, Logos), die von Veranstalterinnen und Veranstaltern
          hochgeladen werden, liegen in deren Verantwortung. Durch das Hochladen versichern
          sie, über die notwendigen Rechte zu verfügen.
        </p>

        <h2>Datenschutz</h2>
        <p>
          Informationen zur Bearbeitung Ihrer Personendaten finden Sie in unserer{' '}
          <a href="/datenschutz">Datenschutzerklärung</a>.
        </p>

        <h2>Anwendbares Recht</h2>
        <p>
          Es gilt Schweizer Recht.
        </p>
      </div>
    </div>
  );
};

export default ImpressumPage;
